/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
function n(n){return n instanceof Float32Array&&n.length>=16}function r(n){return Array.isArray(n)&&n.length>=16}function t(t){return n(t)||r(t)}export{t as isMat4,n as isMat4f32,r as isMat4f64};
